/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Post from '@linc-technologies/linced-common/models/posts/post';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr, hasMany, type AsyncHasMany } from '@warp-drive/legacy/model';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import PostType from '@linc-technologies/linced-common/enums/post-type';
import type Module from '@linc-technologies/linced-common/models/assessments/module';
import moment from 'moment';

// Proto: posts.Post.
export default class _Post extends Post {
  // Subclasses in linced-app extend this class with their own types.
  declare [Type]: string;

  @alias('author.id')
  declare author_id: string | null | undefined;

  @alias('person.id')
  declare person_id: string | null | undefined;

  @hasMany('assessments/module', { async: true, inverse: null })
  declare assessmentModuleIds: AsyncHasMany<Module>;

  @alias('assessmentModuleIds')
  declare assessmentModules: AsyncHasMany<Module>;

  @array('string')
  declare nceaStandardIds: StatefulArray<string>;

  @alias('nceaStandardIds')
  declare nceaStandards: StatefulArray<string>;

  // Is this a Sickbay post
  @attr('boolean', { defaultValue: false })
  declare isSickbay: boolean;

  @computed('date')
  get dateString() {
    // TS-ZERO(date)
    return moment.unix(this.date as number).format('MMM D, YYYY [at] h:mm A');
  }

  @computed('postType', 'person.id', 'id')
  get url() {
    const id = this.id;
    switch (this.postType) {
      case PostType.POST:
        return `/people/${this.get('person.id') as string}/posts/${id}`;
      case PostType.COMMUNITY_NOTICE:
        return `/home/community-notices/${id}`;
      case PostType.STUDENT_NOTICE:
        return `/home/student-notices/${id}`;
      case PostType.STAFF_NOTICE:
        return `/home/daily-notices/${id}`;
      case PostType.TEXT:
        return `/home/text-messages/${id}`;
      case PostType.ATTENDANCE_NOTE:
        return `/people/${this.get('person.id') as string}/attendance`;
      default:
        return `/posts/${id}`;
    }
  }

  @computed('url')
  get analysisUrl() {
    return `${this.url}/analysis`;
  }

  @alias('isSickbay')
  declare isSpecialUse: boolean;
}
